// extracted by mini-css-extract-plugin
module.exports = {"title-header":"MyProfilePage_title-header__3mtGI","studentInfo-center-container":"MyProfilePage_studentInfo-center-container__Unmid"};